import {
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { url } from "../../baseUrl";
import { useSelector } from "react-redux";
import axios from "axios";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import {
  brandUrl,
  button,
  cardBackground,
  invoiceCard,
  lightBackground,
  lightText,
  mainBackgound,
  navbar,
  navbarText,
  white,
} from "../../Assets/Theme/ThemeColors";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";
import isAlpha from "validator/lib/isAlpha";
import isEmail from "validator/lib/isEmail";
import Navbar from "../../Components/Navbar/Navbar";
import { Badge, Descriptions } from "antd";
import CheckoutForm from "../../Components/StripeCardForm/CheckOutForm";
import "./invoice.css";
import StripeCardForm from "../../Components/StripeCardForm/StripeCardForm";
import logo from "../../Assets/images/logo.webp";
import Headerlogo from "../../Assets/images/headerlogo.webp";
import stripeBadge from "../../Assets/images/stripebadge.png";
import comoo from "../../Assets/images/comoo.png";
import masterCard from "../../Assets/images/masterCard.png";
import norton from "../../Assets/images/norton.png";
import visa from "../../Assets/images/visa.png";
import ssl from "../../Assets/images/ssl.png";
import MailIcon from "@mui/icons-material/Mail";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";

// 🎨 NEW GRADIENT COLORS FOR CERTIFIED ACADEMIC WRITERS
const primaryDark = "#1a1e4c";
const primaryLight = "#1a1e4c";
const gradientMain = `linear-gradient(135deg, ${primaryDark} 0%, ${primaryLight} 100%)`;
const gradientDark = `linear-gradient(135deg, #202352 0%, #202352 100%)`;
const lightBg = "#f0f8ff";
const darkBg = "#f6c41f";
const cardBg = "#ffffff";
const textLight = "#4a5568";
const textDark = "#1a202c";

const InvoicePage = () => {
  let { id } = useParams();
  let param = id.split("_");
  const state = useSelector((state) => state.user.data);

  const [data, setData] = useState();
  const [key, setKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isPaid, setIsPaid] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  let invoiceId = param[0];
  console.log("invoiceId", invoiceId);

  // 💰 USD CURRENCY FORMatter
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  useEffect(() => {
    getSpecificTransaction();
  }, []);

  const getSpecificTransaction = async () => {
    setIsLoading(false);
    await axios
      .post(`${url}/transactions/getSpecificTransaction`, {
        _id: invoiceId,
      })
      .then((response) => {
        console.log("response", response.data.data[0]);
        setData(response.data.data[0]);
        console.log("key", response.data.key.publishKey);
        setKey(response.data.key.publishKey);

        if (response.data.data[0].paymentStatus) {
          setIsPaid(true);
        } else {
          setIsPaid(false);
        }

        setIsLoading(true);
      });
  };
  console.log("data", data);
  
  return (
    <>
      {isLoading ? (
        <>
          {/* ========== HEADER - TRANSPARENT, SINGLE COLUMN (CENTER) ========== */}
          <Grid
            container
            xs={12}
            sx={{
              height: "70px",
              background: "transparent",
              color: primaryDark,
              boxShadow: "none",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={Headerlogo} height="45px" alt="Certified Academic Writers" />
            </Grid>
          </Grid>
          
          {/* ========== MAIN CONTENT ========== */}
          <Grid
            container
            style={{
              maxWidth: "100vw",
              minHeight: "calc(100vh - 70px)",
              background: `linear-gradient(135deg, ${lightBg} 0%, #e0f0ff 100%)`,
              display: "flex",
              alignItems: "center",
              flexFlow: "column",
              fontFamily: "Roboto",
              paddingTop: "40px",
              paddingBottom: "60px",
            }}
            sx={{ p: 3 }}
          >
            {/* ========== INVOICE SECTION ========== */}
            <Grid item md={6} xs={12}>
              <Paper
                sx={{
                  background: cardBg,
                  color: textDark,
                  p: 3,
                  paddingTop: "30px",
                  paddingBottom: "30px",
                  borderRadius: "24px",
                  boxShadow: `0 20px 40px rgba(21,71,139,0.15)`,
                  borderTop: `0px solid ${primaryDark}`,
                }}
              >
                <Grid container spacing={2}>
                  {/* Header */}
                  <Grid item container sx={{ mb: 2 }}>
                    <Grid xs={12} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Typography variant="h5" sx={{ 
                        background: gradientMain, 
                        backgroundClip: "text", 
                        WebkitBackgroundClip: "text", 
                        color: "transparent",
                        fontWeight: "bold"
                      }}>
                        INVOICE
                      </Typography>
                      <img src={logo} height="50px" alt="logo" />
                    </Grid>
                  </Grid>
                  
                  {/* Order ID */}
                  <Grid item container>
                    <Grid xs={12}>
                      <Typography
                        variant="subtitle2"
                        component="div"
                        style={{
                          background: gradientMain,
                          color: "white",
                          padding: "6px 16px",
                          borderRadius: "30px",
                          display: "inline-block",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        ORDER ID : {data?.orderId}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Customer Info */}
                  <Grid item container sx={{ mt: 2 }}>
                    <Grid xs={12} md={6}>
                      <Typography variant="subtitle2" sx={{ color: primaryDark, fontWeight: "bold" }}>
                        INVOICE TO
                      </Typography>
                      <Typography variant="body1" fontWeight="bold" sx={{ mt: 1 }}>
                        {data?.custName}
                      </Typography>
                      <Typography variant="body2" sx={{ color: textLight }}>
                        {data?.custEmail}
                      </Typography>
                      <Typography variant="body2" sx={{ color: textLight }}>
                        {data?.custContactNumber}
                      </Typography>
                    </Grid>
                    <Grid xs={12} md={6} sx={{ textAlign: { xs: "left", md: "right" }, mt: { xs: 2, md: 0 } }}>
                      <Typography variant="subtitle2" sx={{ color: primaryDark, fontWeight: "bold" }}>
                        DATE
                      </Typography>
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        {data?.dateTime?.split(",")[0]}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Description Table */}
                  <Grid container sx={{ mt: 3 }}>
                    {/* Table Header */}
                    <Grid container sx={{ 
                      background: gradientMain, 
                      borderRadius: "16px", 
                      p: 1.5, 
                      mb: 1 
                    }}>
                      <Grid xs={8}>
                        <Typography variant="subtitle2" fontWeight="bold" sx={{ color: white }}>
                          Description
                        </Typography>
                      </Grid>
                      <Grid xs={4} sx={{ textAlign: "right" }}>
                        <Typography variant="subtitle2" fontWeight="bold" sx={{ color: white }}>
                          Amount
                        </Typography>
                      </Grid>
                    </Grid>
                    
                    {/* Service Row */}
                    <Grid container sx={{ p: 1.5, borderBottom: "1px solid #e2e8f0" }}>
                      <Grid xs={8}>
                        <Typography variant="body2" fontWeight="500">
                          {data?.discription}
                        </Typography>
                        <Typography variant="caption" sx={{ color: textLight }}>
                          {data?.detailDiscription}
                        </Typography>
                      </Grid>
                      <Grid xs={4} sx={{ textAlign: "right" }}>
                        <Typography variant="body2" fontWeight="500">
                          {formatter.format(data?.amount)}
                        </Typography>
                      </Grid>
                    </Grid>
                    
                    {/* Discount Row */}
                    <Grid container sx={{ p: 1.5, borderBottom: "1px solid #e2e8f0" }}>
                      <Grid xs={8}>
                        <Typography variant="body2">Additional Discount</Typography>
                      </Grid>
                      <Grid xs={4} sx={{ textAlign: "right" }}>
                        <Typography variant="body2" sx={{ color: "#dc2626" }}>
                          -{formatter.format(data?.discount)}
                        </Typography>
                      </Grid>
                    </Grid>
                    
                    {/* Taxes Row */}
                    <Grid container sx={{ p: 1.5, borderBottom: "1px solid #e2e8f0" }}>
                      <Grid xs={8}>
                        <Typography variant="body2">Taxes and Fees</Typography>
                      </Grid>
                      <Grid xs={4} sx={{ textAlign: "right" }}>
                        <Typography variant="body2">
                          {formatter.format(data?.additionalCharges)}
                        </Typography>
                      </Grid>
                    </Grid>
                    
                    {/* Total Row */}
                    <Grid container sx={{ 
                      p: 1.5, 
                      mt: 1, 
                      background: lightBg, 
                      borderRadius: "16px",
                      borderLeft: `0px solid ${primaryDark}`
                    }}>
                      <Grid xs={8}>
                        <Typography variant="h6" fontWeight="bold" sx={{ color: primaryDark }}>
                          PAYABLE AMOUNT
                        </Typography>
                      </Grid>
                      <Grid xs={4} sx={{ textAlign: "right" }}>
                        <Typography variant="h6" fontWeight="bold" sx={{ color: primaryDark }}>
                          {formatter.format(data?.total)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* ========== PAYMENT SECTION ========== */}
            <Grid
              container
              style={{
                marginTop: "30px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid
                item
                md={5}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexFlow: "column",
                }}
              >
                <Grid xs={12} sx={{ mb: 0.5 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      background: gradientMain,
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      color: "transparent",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "1.5rem",
                      lineHeight: 1.2,
                      mb: 0.5,
                    }}
                  >
                    JUST ONE STEP LEFT
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: primaryLight,
                      textAlign: "center",
                      fontSize: "1rem",
                      mb: 1,
                    }}
                  >
                    TO ACTIVATE YOUR SERVICE
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: textLight,
                      textAlign: "center",
                      fontSize: "12px",
                      px: 2,
                      mb: 0.5,
                    }}
                  >
                    We're almost done here, just a few more things that we'd be
                    needing from you to welcome you onboard.
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: primaryDark,
                      textAlign: "center",
                      display: "block",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    🔒 Secure Payment Globally!
                  </Typography>
                </Grid>
                
                {/* Payment Card - Make sure Stripe form shows */}
                <Paper
                  sx={{
                    width: "100%",
                    background: cardBg,
                    borderRadius: "20px",
                    boxShadow: `0 15px 35px rgba(21,71,139,0.15)`,
                    overflow: "visible",
                  }}
                >
                  {/* Amount Header */}
                  <Grid
                    container
                    sx={{
                      background: gradientMain,
                      color: white,
                      py: 1.2,
                      borderRadius: "20px 20px 0 0",
                    }}
                  >
                    <Grid xs={6} sx={{ textAlign: "center" }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ color: white, fontSize: "1rem" }}>
                        AMOUNT
                      </Typography>
                    </Grid>
                    <Grid xs={6} sx={{ textAlign: "center" }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ color: white, fontSize: "1rem" }}>
                        {formatter.format(data?.total)}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Payment Form */}
                  <Grid sx={{ p: 2.5 }}>
                    {isPaid ? (
                      <Typography
                        variant="subtitle1"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#10b981",
                          color: "white",
                          padding: "12px",
                          borderRadius: "12px",
                        }}
                      >
                        <TaskAltIcon sx={{ mr: 1, fontSize: "1.2rem" }} />
                        Already Paid
                      </Typography>
                    ) : (
                      <StripeCardForm
                        transactionId={invoiceId}
                        amount={Number(data?.total)}
                        account={data?.account}
                        stripeKey={key}
                      />
                    )}

                    {/* Payment Badges */}
                    <Grid sx={{ pt: 1.5, mt: 0.5 }}>
                      <img src={stripeBadge} width="100%" alt="secure payment" />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
          
          {/* ========== PAYMENT LOGOS SECTION - RESPONSIVE ========== */}
          <Grid
            container
            xs={12}
            sx={{
              py: { xs: 2, sm: 2.5, md: 3 },
              px: { xs: 2, sm: 3, md: 4 },
              width: "100%",
              background: darkBg,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderTop: `1px solid rgba(255,255,255,0.2)`,
              borderBottom: `1px solid rgba(255,255,255,0.2)`,
            }}
          >
            <Grid 
              container 
              sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center",
                gap: { xs: 1, sm: 2, md: 3 },
                flexWrap: "wrap",
              }}
            >
              <Grid item sx={{ p: { xs: 0.5, sm: 1, md: 1.5 }, opacity: 0.9, transition: "0.3s", "&:hover": { opacity: 1, transform: "scale(1.05)" } }}>
                <img src={ssl} height="45px" width="70px" alt="SSL" style={{ objectFit: "contain" }} />
              </Grid>
              <Grid item sx={{ p: { xs: 0.5, sm: 1, md: 1.5 }, opacity: 0.9, transition: "0.3s", "&:hover": { opacity: 1, transform: "scale(1.05)" } }}>
                <img src={norton} height="25px" width="60px" alt="Norton" style={{ objectFit: "contain" }} />
              </Grid>
              <Grid item sx={{ p: { xs: 0.5, sm: 1, md: 1.5 }, opacity: 0.9, transition: "0.3s", "&:hover": { opacity: 1, transform: "scale(1.05)" } }}>
                <img src={comoo} height="30px" width="60px" alt="Comodo" style={{ objectFit: "contain" }} />
              </Grid>
              <Grid item sx={{ p: { xs: 0.5, sm: 1, md: 1.5 }, opacity: 0.9, transition: "0.3s", "&:hover": { opacity: 1, transform: "scale(1.05)" } }}>
                <img src={visa} height="25px" width="65px" alt="Visa" style={{ objectFit: "contain" }} />
              </Grid>
              <Grid item sx={{ p: { xs: 0.5, sm: 1, md: 1.5 }, opacity: 0.9, transition: "0.3s", "&:hover": { opacity: 1, transform: "scale(1.05)" } }}>
                <img src={masterCard} height="20px" width="65px" alt="MasterCard" style={{ objectFit: "contain" }} />
              </Grid>
            </Grid>
          </Grid>

          {/* ========== FOOTER ========== */}
          <Grid
            container
            xs={12}
            sx={{
              py: 1.5,
              background: gradientMain,
              color: white,
            }}
          >
            <Grid
              xs={12}
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                px: 2,
              }}
            >
              <Typography variant="body2" sx={{ color: white, fontWeight: "500", fontSize: { xs: "10px", sm: "12px" } }}>
                © {new Date().getFullYear()} First Class Assignments. All Rights Reserved.
              </Typography>
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid container sx={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: lightBg }}>
          <CircularProgress sx={{ color: primaryDark }} />
          <Typography variant="h6" sx={{ ml: 2, color: primaryDark }}>LOADING...</Typography>
        </Grid>
      )}
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
};

export default InvoicePage;